import { ApiBase } from '../apiBase';

export class ApiBusinessBaseBase extends ApiBase {
  public static get baseUrl(): string {
    return '/business_base';
  }
}
